import { SET_ITEMS, SHOW_MODAL, HIDE_MODAL } from '../mutations.types';

export default {
  namespaced: true,
  state: {
    visible: false,
    component: null,
    items: null
  },
  mutations: {
    [SET_ITEMS](state, items) {
      state.items = items;
    },
    [SHOW_MODAL](state, component) {
      state.visible = true;
      state.component = component;
    },
    [HIDE_MODAL](state) {
      state.visible = false;
    }
  }
};
